import {
  DRAG_AND_DROP_TEXT,
  FILL_IN_THE_BLANK,
  INFORMATION_CONTENT,
  OPEN_QUESTION,
  RANKING_TEXT
} from 'constants/questionTypes';
import shuffle from 'lodash.shuffle';
import { QuestionsState } from 'store/questions/types';

export const shuffleAnswerOptions = (answerOptions: any[]): any[] => {
  if (answerOptions.length <= 1) {
    return answerOptions;
  }

  let shuffledArray = shuffle(answerOptions);
  let iterationCount = 0;

  const MAX_RETRIES = 10;

  while (
    JSON.stringify(shuffledArray) === JSON.stringify(answerOptions) &&
    iterationCount < MAX_RETRIES
  ) {
    iterationCount++;
    shuffledArray = shuffle(shuffledArray);
  }

  return shuffledArray;
};
export const isResponseTypeObject = (question: QuestionsState) =>
  [
    FILL_IN_THE_BLANK,
    OPEN_QUESTION,
    RANKING_TEXT,
    INFORMATION_CONTENT,
    DRAG_AND_DROP_TEXT
  ].includes(question.type);

export const wasAnswered = (question: QuestionsState): boolean =>
  question.isPreviousAnswerCorrect || question.isAnswerChanged;

export const isAttempted = (question: QuestionsState) =>
  isResponseTypeObject(question)
    ? wasAnswered(question)
    : wasAnswered(question) || !!question.response?.length;

export const filterAttempted = (questions: Array<QuestionsState>) =>
  questions.filter((question: any) => {
    if (isAttempted(question)) {
      return true;
    }
    return false;
  }).length;

export default shuffleAnswerOptions;
